import * as React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import images from "../../../global-styles/images";
import { appLogger } from "../../../utils";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  boxShadow: "none",
  background: "none",
}));

const initialWidgetInfo = {
  transformOrigin: "right 0px",
  transform: "",
  top: "",
  left: "",
  right: "",
  bottom: "",
};

const WidgetPreview = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "WidgetPreview",
      component: "add-product",
      fileName: "WidgetPreview.tsx",
      prpos: props,
    },
  });
  const { productParams, widgetInfo } = props;

  const [previewAgent, setPreviewAgent] = React.useState<boolean>(false);
  const [widgetModalInfo, setWidgetModalInfo] =
    React.useState(initialWidgetInfo);

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  React.useMemo(() => {
    if (widgetInfo?.btnPosition === "RIGHT_MIDDLE") {
      const rightMiddle = {
        transformOrigin: "top right",
        right: "0",
        top: "50%",
        transform: "rotate(90deg) translateX(50%)",
        left: "",
        bottom: "",
      };
      setWidgetModalInfo(rightMiddle);
    } else if (widgetInfo?.btnPosition === "RIGHT_BOTTOM") {
      const rightBottom = {
        transformOrigin: "bottom right",
        right: "0",
        bottom: "0",
        transform: " rotate(90deg) translateY(100%)",
        top: "",
        left: "",
      };
      setWidgetModalInfo(rightBottom);
    } else if (widgetInfo?.btnPosition === "LEFT_MIDDLE") {
      const leftMiddle = {
        transformOrigin: "top left",
        left: "0",
        top: "50%",
        transform: "rotate(-90deg) translateX(-50%)",
        bottom: "",
        right: "",
      };
      setWidgetModalInfo(leftMiddle);
    } else if (widgetInfo?.btnPosition === "LEFT_BOTTOM") {
      const leftBottom = {
        transformOrigin: "bottom left",
        left: "0",
        bottom: "0",
        transform: "rotate(-90deg) translateY(100%)",
        top: "",
        right: "",
      };
      setWidgetModalInfo(leftBottom);
    } else if (widgetInfo?.btnPosition === "BOTTOM_RIGHT") {
      const bottomRight = {
        top: "auto",
        bottom: "0",
        left: "auto",
        right: "0",
        transformOrigin: "unset",
        transform: "",
      };
      setWidgetModalInfo(bottomRight);
    } else if (widgetInfo?.btnPosition === "BOTTOM_LEFT") {
      const bottomLeft = {
        top: "auto",
        bottom: "0",
        left: "0",
        right: "auto",
        transformOrigin: "unset",
        transform: "",
      };
      setWidgetModalInfo(bottomLeft);
    } else if (widgetInfo?.btnPosition === "CUSTOM") {
      const custom = {
        top: widgetInfo?.customTop,
        bottom: widgetInfo?.customBottom,
        left: widgetInfo?.customLeft,
        right: widgetInfo?.customRight,
        transformOrigin: widgetInfo?.transformOrigin,
        transform: `rotate(${widgetInfo?.rotation}deg)`,
      };
      setWidgetModalInfo(custom);
    }
  }, [
    widgetInfo?.btnPosition,
    widgetInfo?.customTop,
    widgetInfo?.customBottom,
    widgetInfo?.customLeft,
    widgetInfo?.customRight,
  ]);

  function createElementFromHTML(htmlString: any) {
    const svgStr = htmlString;
    const svg = new Blob([svgStr], { type: "image/svg+xml" });
    const url = URL.createObjectURL(svg);
    return url;
  }

  return (
    <>
      <Typography className="prev-text-titile">
        Widget Settings: Preview &nbsp;
      </Typography>
      {!previewAgent && (
        <Grid container justifyContent="center">
          <Typography
            id="genset-toggle-fullscreen"
            className="zoomicons guideTourViewActualSize"
            onClick={handleTogglePreview}
            sx={{ color: "#0157FF", fontSize: 12, cursor: "pointer" }}
          >
            Click to preview actual size
          </Typography>
        </Grid>
      )}
      <div>
        <Grid
          container
          sx={{
            marginTop: "8px",
            background: "#fff",
            p: 2,
            border: "1px solid #dbdce0",
            boxShadow:
              "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
          }}
        >
          <Box className="accordion-wrap" sx={{ width: "100%" }}>
            <Typography className="title">Feedback Button Preview</Typography>
            <div style={{ lineHeight: 1 }}>
              <img src={images.urlbg} alt="Cuvo Logo" />
            </div>
            <Box className="feedbtn-wrap">
              <Button
                disableRipple
                style={{
                  width: "auto",
                  height: 20,
                  lineHeight: 40,
                  borderRadius: widgetInfo?.borderRadius,
                  backgroundColor: widgetInfo?.buttonColor,
                  color: widgetInfo?.buttonTextColor,
                  textAlign: "center",
                  fontSize: 5,
                  fontFamily: widgetInfo?.fontSelect,
                  fontWeight: widgetInfo?.fontWeight,
                  fontStyle: widgetInfo?.fontStyle,
                  transform: `rotate(${widgetInfo?.rotation || 90}deg)`,
                  textTransform: "none",
                  position: "absolute",
                  top: widgetInfo?.customTop,
                  bottom: widgetInfo?.customBottom,
                  left: widgetInfo?.customLeft,
                  right: widgetInfo?.customRight,
                  margin: widgetInfo?.margin,
                  padding: widgetInfo?.padding,
                  transformOrigin: widgetInfo?.transformOrigin,
                }}
              >
                {productParams.productParams?.products[0]?.feedbackAgentSettings
                  .widgetLookAndFeel.icon && (
                  <>
                    <img
                      width="10"
                      height="10"
                      src={createElementFromHTML(
                        productParams.productParams?.products[0]
                          ?.feedbackAgentSettings.widgetLookAndFeel.icon
                      )}
                    />
                    &nbsp; &nbsp;
                  </>
                )}
                {widgetInfo?.buttonText}
              </Button>
            </Box>
            <div>
              <img src={images.taskbarbg} alt="Cuvo Logo" />
            </div>
          </Box>
        </Grid>
      </div>
      {previewAgent && (
        <Dialog
          open={previewAgent}
          onClose={handleTogglePreview}
          maxWidth="xl"
          fullWidth
        >
          <DialogContent
            sx={{
              height: "800px",
              padding: 0,
              overflow: "hidden",
            }}
          >
            <Box className="feedbtn-container">
              <Button
                disableRipple
                style={{
                  width: "auto",
                  height: 20,
                  lineHeight: 20,
                  borderRadius: widgetInfo?.borderRadius,
                  backgroundColor: widgetInfo?.buttonColor,
                  color: widgetInfo?.buttonTextColor,
                  textAlign: "center",
                  fontSize: 20,
                  fontFamily: widgetInfo?.fontSelect,
                  fontWeight: widgetInfo?.fontWeight,
                  fontStyle: widgetInfo?.fontStyle,
                  // transform: `rotate(${widgetInfo?.rotation || 90}deg)`,
                  textTransform: "none",
                  position: "absolute",
                  // top: widgetInfo?.customTop,
                  // bottom: widgetInfo?.customBottom,
                  // left: widgetInfo?.customLeft,
                  // right: widgetInfo?.customRight,
                  margin: widgetInfo?.margin,
                  padding:
                    widgetInfo?.padding === "10px"
                      ? "30px"
                      : widgetInfo?.padding,
                  // transformOrigin: widgetModalInfo?.transformOrigin,
                  ...widgetModalInfo,
                }}
              >
                {productParams.productParams?.products[0]?.feedbackAgentSettings
                  .widgetLookAndFeel.icon && (
                  <>
                    <img
                      width="10"
                      height="10"
                      src={createElementFromHTML(
                        productParams.productParams?.products[0]
                          ?.feedbackAgentSettings.widgetLookAndFeel.icon
                      )}
                    />
                    &nbsp; &nbsp;
                  </>
                )}
                {widgetInfo?.buttonText}
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default WidgetPreview;
